import { ReactElement, useMemo } from 'react';
import styles from './PlaybackTimestamp.module.scss';
import { useLocaleFormatter } from '@customer/shared/hooks/useLocaleFormatter';
import Skeleton from 'react-loading-skeleton';
import {
  InvestigationEnitityIdProps,
  useInvestigationEntity,
} from '@customer/store/slices/investigationsSlice';

export const PlaybackTimestamp = ({
  siteId,
  investigationId,
}: InvestigationEnitityIdProps): ReactElement => {
  const { showTimeOnlyFromMillis: fromMillis } = useLocaleFormatter();

  const { interactionStartTime, currentRawTrack, playback } = useInvestigationEntity({
    siteId,
    investigationId,
  });

  const displayTime = useMemo<string>(() => {
    const time = playback?.currentTime ?? currentRawTrack?.time ?? interactionStartTime;
    return typeof time === 'number' ? fromMillis(time) : '';
  }, [interactionStartTime, currentRawTrack?.time, playback?.currentTime, fromMillis]);

  return (
    <div className={styles.timestamp}>
      {displayTime ? displayTime : <Skeleton height={22} width={120} />}
    </div>
  );
};

export default PlaybackTimestamp;
